import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { CalculationDetailPage } from '@/features/budget-calculator/calculation-detail-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/budget-calculator/$calculationId'
)({
  beforeLoad: async () =>
    requireRoles(['owner', 'admin', 'support_coordinator', 'team_leader']),
  component: CalculationDetailPage,
})
